/* global axios */
import ApiClient from '../ApiClient';

class InstagramChannel extends ApiClient {
  constructor() {
    super('instagram_indicators', { accountScoped: true });
  }

  create(params) {
    return axios.post(
      `${this.url.replace(
        this.resource,
        ''
      )}callbacks/register_instagram_account`,
      params
    );
  }

  reauthorize({ code, inboxId }) {
    return axios.post(
      `${this.url.replace(
        this.resource,
        ''
      )}callbacks/reauthorize_instagram_account`,
      { code, inbox_id: inboxId }
    );
  }

  migrate({ code, inboxId }) {
    return axios.post(
      `${this.url.replace(
        this.resource,
        ''
      )}callbacks/migrate_instagram_account`,
      { code, inbox_id: inboxId }
    );
  }
}

export default new InstagramChannel();
